import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import { editValidationRule, getValidationRules, postValidationRule } from 'api/validation-rules';
// import { ValidationRule } from 'store/admin/validationRules/types';
import { SagaPayload } from 'types';
import {
  requestValidationRules,
  getValidationRulesSuccess,
  getValidationRulesError,
  createValidationRuleSuccess,
  createValidationRuleError,
  updateValidationRuleSuccess,
  updateValidationRuleError,
  requestUpdateValidationRule,
  requestCreateValidationRule,
} from './slice';

export function* validationRulesRequestSaga() {
  try {
    const response: AxiosResponse<any[]> = yield call(getValidationRules(), {});
    if (response) {
      yield put(getValidationRulesSuccess(response.data));
    }
  } catch (error: any) {
    yield put(getValidationRulesError(error?.message ?? 'Unknown error'));
  }
}

export function* createValidationRuleRequestSaga({ payload }: SagaPayload<any>) {
  try {
    const response: AxiosResponse<any> = yield call(postValidationRule(payload), payload);
    yield put(createValidationRuleSuccess(response.data));
  } catch (error: any) {
    yield put(createValidationRuleError(error?.message ?? 'Unknown error'));
  }
}

export function* updateValidationRuleRequestSaga({ payload }: SagaPayload<any>) {
  try {
    const { id, ...data } = payload ?? {};
    const response: AxiosResponse<any> = yield call(editValidationRule(data, id), {});
    yield put(updateValidationRuleSuccess(response.data));
  } catch (error: any) {
    yield put(updateValidationRuleError(error?.message ?? 'Unknown error'));
  }
}

export function* validationRulesRequestWatchSaga() {
  yield takeLatest(requestValidationRules, validationRulesRequestSaga);
}

export function* validationRulesCreateWatchSaga() {
  yield takeLatest(requestCreateValidationRule, createValidationRuleRequestSaga);
}

export function* validationRulesUpdateWatchSaga() {
  yield takeLatest(requestUpdateValidationRule, updateValidationRuleRequestSaga);
}
